export default class brazePushTracking {
    constructor() {
        this.brazeParamKeys = [
            'brazeid',
            'brazecampaignname',
            'brazecampaignid',
            'brazemessage',
            'brazesegmentname',
            'brazesegmentid',
        ];
        this.searchString = '';
        this.brazeTracking = {};
        this.urlParams = {};
        this.init();
    }

    init() {
        const urlSearchParams = new URLSearchParams(window.location.search);
        this.urlParams = Object.fromEntries(urlSearchParams.entries());

        if (this.urlParams.brazeid) {
            for (const param in this.urlParams) {
                if (this.brazeParamKeys.includes(param)) {
                    this.brazeTracking[param] = this.urlParams[param] ?? '';
                } else {
                    this.searchString += `${param}=${this.urlParams[param]}&`;
                }
            }

            if (this.searchString.length > 0) {
                this.searchString = '?' + this.searchString.slice(0, -1);
            }
        }
    }

    appendTrackingData(existingTracking) {
        if (!this.urlParams.brazeid) {
            return existingTracking;
        }

        return {
            ...existingTracking,
            ...this.brazeTracking,
        };
    }

    removeParamsFromUrl() {
        if (!this.urlParams.brazeid) {
            return;
        }

        window.history.replaceState(
            {},
            document.title,
            window.location.pathname + this.searchString,
        );
    }
}
